// // Use $ instead of jQuery without replacing global $
(function ($) {
    $(document).ready(function () {
        $('body .static-intro .col-outer .counter .value span.counter').counterUp({
            delay: 5,
            time: 1000
        });
    });
})(jQuery);

